import React from 'react';

import './App.css';

const Commands = {
  START: 'Start',
  PAUSE: 'Pause',
  STOP: 'Stop',
  BOX_INFO: 'Box Info',
  SET_MODE: 'Set Mode',
  GET_DATA: 'Get Data',
  INIT_CONNECTION: 'InitConnection',
  SHOW_ACTIVE_CONNECTIONS: 'ActiveConnections'
}

class App extends React.Component {
  socket = null

  state = {
    // command: 'InitConnection 866308066295932',
    command: '',
    activeBox: '',
    responses: [],
    isConnected: false,
    availableBoxes: [],
    isFirstMeterSelected: true
  }

  componentDidMount() {
    this.wsConnection();
  }

  wsConnection = () => {    
    // IMP: do not keep the url to localhost while building the docker image
    this.socket = new WebSocket("ws://34.121.179.101:8088");
    // this.socket = new WebSocket("ws://localhost:8088");

    this.socket.addEventListener("open", (event) => {
      this.setState({ isConnected: true });
      this.setState((oldState) => ({ responses: ['CONNECTION OPENED', ...oldState.responses] }))
    });
    
    this.socket.addEventListener("message", (event) => {
      this.setState((oldState) => ({ responses: [event.data, ...oldState.responses] }))
      this.promiseCallback?.(event.data)
    });

    this.socket.addEventListener("close", (event) => {
      this.setState({ isConnected: false });
      this.setState((oldState) => ({ responses: ['CONNECTION CLOSED', ...oldState.responses] }))
    });

    this.socket.addEventListener("error", (event) => {
      this.setState((oldState) => ({ responses: ['ERRORED', ...oldState.responses] }))
    });

  }

  sendCommand(command) {
    if (this.socket) {
      this.setState((oldState) => ({ responses: [command, ...oldState.responses] }))
      this.socket.send(command)
      return new Promise((resolve, reject) => {
        this.promiseCallback = (responseValue) => {
          resolve(responseValue)
        }
      })
    }
  }

  onChangeCommand = (command) => {
    this.setState({ command: command.target.value });    
  }

  handleButtonClick = (cmd, ...params) => {
    console.log(cmd);
    switch (cmd) {
      case Commands.START:
        this.sendCommand(`Start ${String(params)}>${this.state.activeBox}`);
        break;
      case Commands.PAUSE:
        this.sendCommand(`Pause ${String(params)}>${this.state.activeBox}`);

        break;
      case Commands.STOP:
        this.sendCommand(`Stop ${String(params)}>${this.state.activeBox}`);

        break;
      case Commands.SET_MODE:
        this.sendCommand(`SetMode 2>${this.state.activeBox}`);

        break;
      case Commands.BOX_INFO:
        this.sendCommand(`BoxInfo>${this.state.activeBox}`);

        break;
      case Commands.GET_DATA:
        this.sendCommand(`GetData ${String(params)}>${this.state.activeBox}`);
        break;
      case Commands.INIT_CONNECTION:
        this.setState({ activeBox: String(params) })
        this.sendCommand(`InitConnection ${String(params)}`);
        break;
      case Commands.SHOW_ACTIVE_CONNECTIONS:
        this.sendCommand('ActiveConnections').then((response) => {
          const boxesStr = response.split(' ')?.[1]
          const boxes = boxesStr?.split(',')
          const filteredBoxes = boxes.filter((box) => box)
          this.setState({ availableBoxes: filteredBoxes })
        })
        break;
    
      default:
        break;
    }
  }

  handleToggle = () => {
    this.setState((oldState) => ({ isFirstMeterSelected: !oldState.isFirstMeterSelected }))
  }

  renderBoxLogger = () => (
    <div style={{ flex: 1, padding: '10px', borderRight: '1px solid #ccc' }}>
      <h2>Box Logs</h2>
      <div style={{ flex: 1, height: '500px', overflowY: 'scroll' }} ref={(node) => { this.responseDiv = node }}>
      {this.state.responses.map((response, index) => (
        <div key={`${index}log`} style={{ fontSize: 12, flex: 1, textAlign: 'left' }}>{response}</div>
      ))}
      </div>
    </div>
  )

  renderMeterCheckboxes = () => {
    return (
      <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', width: 100, height: 100, top: 0, right: 0 }}>
        <div>
          Meter 1
          <input
            type="checkbox"
            onChange={this.handleToggle}
            style={{ width: 18, height: 18 }}
            checked={this.state.isFirstMeterSelected}
          />
        </div>
        <div>
          Meter 2
          <input
            type="checkbox"
            onChange={this.handleToggle}
            style={{ width: 18, height: 18 }}
            checked={!this.state.isFirstMeterSelected}
          />
        </div>
      </div>
    )
  }

  renderCommandSender = () => (
    <div style={{ flex: 1, display: 'flex', maxHeight: 50 }}>
      <input
        type="text"
        id="commandInput"
        placeholder="eg: BoxInfo"
        style={{ width: '100%' }}
        onChange={this.onChangeCommand} />
      <button style={{ width: 150 }} onClick={() => this.sendCommand(this.state.command)}>Send Command</button>
    </div>
  )

  renderActiveBoxSelector = () => (
    <div style={{ flex: 1 }}>
      <button style={{ width: '60%'}} onClick={() => this.handleButtonClick(Commands.SHOW_ACTIVE_CONNECTIONS)}>Show Active Boxes</button>
      {this.state.availableBoxes.length > 0 && (
        <div style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '10px' }}>
            {this.state.availableBoxes.map((box, index) => {
              const backgroundColor = this.state.activeBox === box ? '#4bbe83' : ''
              return <button style={{ width: '40%', backgroundColor }} onClick={() => this.handleButtonClick(Commands.INIT_CONNECTION, box)}>{box}</button>
            })}
          </div>
        </div>
      )}
    </div>
  )

  render() {
    const meterIndex = this.state.isFirstMeterSelected ? 1 : 2

    return (
      <>
        <h1 style={{ textAlign: 'center' }}>Panda Box Control</h1>
        {this.renderMeterCheckboxes()}
        <div className="App" style={{ flex: 1, display: 'flex', width: '100vw', height: 'auto' }}>
          {/* Left Section - Full Log Box */}
          {this.renderBoxLogger()}

          {/* Right Section - Buttons */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '10px' }}>
            <div>
              <h2>Commands</h2>
              <button style={{ width: '40%'}} onClick={() => this.handleButtonClick(Commands.START, meterIndex)}>Start</button>
              <button style={{ width: '40%'}} onClick={() => this.handleButtonClick(Commands.PAUSE, meterIndex)}>Pause</button>
              <button style={{ width: '40%'}} onClick={() => this.handleButtonClick(Commands.STOP, meterIndex)}>Stop</button>
              <button style={{ width: '40%'}} onClick={() => this.handleButtonClick(Commands.SET_MODE)}>Set Mode</button>
              <button style={{ width: '40%'}} onClick={() => this.handleButtonClick(Commands.BOX_INFO)}>Box Info</button>
              <button style={{ width: '40%'}} onClick={() => this.handleButtonClick(Commands.GET_DATA, meterIndex, 0)}>Get Data</button>
            </div>
            <div style={{ width: '50%', alignSelf: 'center', margin: 16, borderBottom: '1px solid #ccc' }} />
            {this.renderActiveBoxSelector()}
            {this.renderCommandSender()}
          </div>
        </div>
      </>
    )
  }
}

export default App;
  